
export const ACTION = {
  CREATE_NEW_DRAFT: 'CASE:NEW_DRAFT',
  CREATE_NEW_DRAFT_FAILURE: 'CASE:FAIL_NEW_DRAFT'
};

export class CreateNewDraft {
  public type: string = ACTION.CREATE_NEW_DRAFT;
  public caseTypeId: number;

  constructor(caseTypeId: number) {
    this.caseTypeId = caseTypeId;
  }
}

export class CreateNewDraftFailure {
  public type: string = ACTION.CREATE_NEW_DRAFT_FAILURE;
  public id: number;
  public error: any;
  public constructor(id: number, error: any) {
    this.id = id;
    this.error = error;
  }
}
